export const typeContratAvenant = Object.freeze(['Avenant'])
